import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import PageLayout from '../components/common/PageLayout';
import './KonfHubEnroll.css';

const KONFHUB_SCRIPT_URL = 'https://widget.konfhub.com/widget.js';

const BUTTON_IDS = {
  'salesforce-ai-developer': 'btn_f73dfe6e992a',
  'salesforce-developer': 'btn_f73dfe6e992a', // old slug support
  'salesforce-devops-copado-agentia': 'btn_483b56d18976',
};

const KonfHubEnroll = () => {
  const { courseSlug } = useParams();

  const buttonId =
    BUTTON_IDS[courseSlug] || BUTTON_IDS['salesforce-ai-developer'];

  useEffect(() => {
    // Remove existing script if present
    const existingScript = document.getElementById('konfhub-widget-script');
    if (existingScript) {
      existingScript.remove();
    }

    // Clear any previously rendered widget
    const widgetContainer = document.getElementById(buttonId);
    if (widgetContainer) {
      widgetContainer.innerHTML = '';
    }

    const script = document.createElement('script');
    script.id = 'konfhub-widget-script';
    script.src = KONFHUB_SCRIPT_URL;
    script.setAttribute('button_id', buttonId);
    script.async = true;

    document.body.appendChild(script);

    return () => {
      const scriptToRemove = document.getElementById(
        'konfhub-widget-script'
      );
      if (scriptToRemove) {
        scriptToRemove.remove();
      }
    };
  }, [buttonId]);

  return (
    <PageLayout className="konfhub-enroll-layout">
      <section className="konfhub-enroll">
        <div className="konfhub-enroll-container">
          <h1 className="konfhub-enroll-title">
            Enroll in the course
          </h1>

          <p className="konfhub-enroll-desc">
            Select your batch and complete enrollment with payment below.
          </p>

          <div
            id={buttonId}
            className="konfhub-enroll-widget"
            aria-live="polite"
          />
        </div>
      </section>
    </PageLayout>
  );
};

export default KonfHubEnroll;